<!-- <h2>Login is required to access this area</h2>
<div>
    <button type="button" class="btn btn-primary" (click)="login()">Login</button>
    <button type="button" class="btn btn-default" (click)="goback()">Back</button>
    <button type="button" class="btn btn-default" (click)="logout()">Logout</button>
</div> -->
<button type="button" *ngIf="!isUserisAuthorized()" class="k-button k-primary ml-4" (click)="login()" role="button"> Login</button>   
<button type="button" *ngIf="isUserisAuthorized()" class="k-button k-primary ml-4" (click)="logout()">Logout</button>